export default __webpack_public_path__ + "static/media/logo_site.be59658b.png";